import { render, staticRenderFns } from "./OrganizationCreate.vue?vue&type=template&id=7b22d53a&scoped=true"
import script from "./OrganizationCreate.vue?vue&type=script&lang=js"
export * from "./OrganizationCreate.vue?vue&type=script&lang=js"
import style0 from "./OrganizationCreate.vue?vue&type=style&index=0&id=7b22d53a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b22d53a",
  null
  
)

export default component.exports